// Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React, { useState } from 'react'
import moment from 'moment'

// swagger-ui
import SwaggerUI from 'swagger-ui-react'
import 'swagger-ui-react/swagger-ui.css'

// services
import { updateUsagePlansAndApisList, getApi } from 'services/api-catalog'

// components
import ApisMenu from 'components/ApisMenu'
import PageWithSidebar from 'components/PageWithSidebar'
import SwaggerLayoutPlugin from 'components/SwaggerUiLayout'

// state
import { store } from 'services/state.js'
import { observer } from 'mobx-react'

export default observer(({ match }) => {
    const [spec, setSpec] = useState(null);
    const [initialized, setInitialized] = useState(false);

    if (!initialized) {
        updateUsagePlansAndApisList(true);
        setInitialized(true);
    }

    if (!spec) {
        getApi(match.params.apiId || 'ANY', true, match.params.stage, true)
            .then(api => {
                const now = moment();
                const actualsAvailable = now.clone().subtract(61, 'days');
                api.swagger.paths = Object.keys(api.swagger.paths).reduce((acc, path) => {
                    const pathObj = api.swagger.paths[path];
                    acc[path] = Object.keys(pathObj).reduce((acc, method) => {
                        const methodObj = pathObj[method];
                        methodObj.parameters = methodObj.parameters.map(param => {
                            if (param.schema.format && param.schema.format.toLowerCase() === 'date' && !param.schema.example) {
                                if (path.match(/actuals/)) {
                                    param.schema.example = actualsAvailable.format('YYYY-MM-DD');
                                } else {
                                    param.schema.example = now.format('YYYY-MM-DD');
                                }
                            } else if (param.schema.format && param.schema.format.toLowerCase() === 'datetime' && !param.schema.example) {
                                param.schema.example = now.format('YYYY-MM-DDTHH:mm:ss');
                            }
                            return param;
                        })
                        acc[method] = methodObj;
                        return acc;
                    }, {});
                    return acc;
                }, {});
                setSpec(api.swagger);
            })
    }

    return (
        <PageWithSidebar
            sidebarContent={<ApisMenu path={match} activateFirst={true}/>}
            SidebarPusherProps={{className: 'swagger-section'}}>
            {spec && <SwaggerUI
                className="swagger-ui-wrap"
                tryItOutEnabled={true}
                plugins={[SwaggerLayoutPlugin]}
                style={{padding: '0 20px'}}
                defaultModelsExpandDepth={-1}
                spec={spec}
                onComplete={system => system.preauthorizeApiKey('ApiKeyAuth', store.apiKey)}
            />}
        </PageWithSidebar>
    )
});
